import React from "react";
import { PromoCodeInfoType } from "../../SignUpFormTypes/signUpFormTypes";
import Sparkle from "../../svgs/Sparkle";
import { injectStylesInString } from "./signUpHelpers";

const FormPromoCodeMessage: React.FC<{ promoCodeInfo: PromoCodeInfoType }> = ({
  promoCodeInfo: { referralName },
}) => {
  const PartnerMessage = () => (
    <span
      className="text-[#333] text-sm sm:text-[13px] font-normal not-italic leading-[165%] *:font-semibold"
      dangerouslySetInnerHTML={{
        __html: injectStylesInString(
          referralName,
          "a",
          "underline hover:no-underline"
        ),
      }}
    />
  );

  return (
    <div className="flex p-3 items-center gap-3 sm:gap-2 self-stretch rounded-xl bg-mint-300 w-full">
      <div className="size-[72] sm:size-12">
        <Sparkle />
      </div>
      <PartnerMessage />
    </div>
  );
};

export default FormPromoCodeMessage;
